import type {FilterObject} from 'nutshell-core/types';

import {Stack} from 'shells/layout/stack/stack';
import {Select} from 'shells/select/select';

import type {ContactFilter} from 'nutshell-graphql-types';

import {ReportControlsContainer} from '../report-controls-container';
import type {ReportKey, ReportURLParams} from '../report-types';

import {TAB_OPTIONS} from './consts';

interface Props {
    reportKey: ReportKey;
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => void;
    urlParams: ReportURLParams<any>;
    selectedThreadType: ContactFilter;
    setSelectedThreadType: (threadType: ContactFilter) => void;
}

export const ChatbotReportControls = (props: Props) => {
    return (
        <Stack isHorizontal={true} alignItems='center' justifyContent='space-between'>
            <Select
                value={TAB_OPTIONS.find((option) => option.id === props.selectedThreadType)}
                labelKey='label'
                selectValues={TAB_OPTIONS}
                styleOptions={{filled: true, color: 'blue'}}
                onChange={(option: {id: ContactFilter; label: string}) =>
                    props.setSelectedThreadType(option.id)
                }
            />
            <ReportControlsContainer
                reportKey={props.reportKey}
                activeFilters={props.activeFilters}
                reportParams={props.urlParams.report}
                onParamChange={props.onParamChange}
                noPadding={true}
            />
        </Stack>
    );
};
